import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from '~/reducers';

export const useInitializeWatcher = () => {
  const isInitializingApp = useSelector((state: AppState) => state.app.isInitializingApp);
  const isUserInfoFetched = useSelector(
    (state: AppState) => state.authentication.isUserInfoFetched
  );
  const isAuthenticated = useSelector((state: AppState) => state.authentication.authenticated);

  const isAuthenticatedAndNotFetched = isAuthenticated && !isUserInfoFetched;

  const initializing = useMemo<boolean>(
    () => isInitializingApp || isAuthenticatedAndNotFetched,
    [isAuthenticatedAndNotFetched, isInitializingApp]
  );

  return {
    initializing,
  };
};
